/*
 * Project: forca
 * File Created: Monday, 8th November 2021 1:02:50 pm
 * Author: Teodor Moquist (teodor@moquist.dk)
 */

import React from 'react';

import RelatedContentSlider from './relatedContentSlider.component';

export const RelatedContentSliderContainer = (props: any) => {

	const containerProps = () => {
		const { currentBlock = null } = props;

		if (!currentBlock) {
			return props;
		}

		const {
			relateretIndholdList,
			currentBlock: {
				overskrift,
				elementMargin
			}
		} = props;

		const boxes = [];

		if (relateretIndholdList.length > 0) {
			relateretIndholdList.map(item => {
				const { link } = item;
				item = item.currentBlock;

				boxes.push({
					title: item.title,
					content: item.content,
					linkText: item.linkText,
					link: link,
					isButton: item.isButton
				});
			});
		}

		return {
			title: overskrift,
			boxes,
			elementMargin
		};
	};

	return (
		<RelatedContentSlider
			{ ...containerProps() }
		/>
	);
};

export default RelatedContentSliderContainer;